/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
 (function($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Toolbox = {
        doAnimations:function(elements) {
            var animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            elements.each(function() {
                var $this = $(this);
                var $animationDelay = $this.data('delay');
                var $animationType = 'animated ' + $this.data('animation');
                $this.css({
                    'animation-delay': $animationDelay,
                    '-webkit-animation-delay': $animationDelay
                });
                $this.addClass($animationType).one(animationEndEvents, function() {
                    $this.removeClass($animationType);
                });
            });
        }
    };

    var Sage = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                //For Firefox we have to handle it in JavaScript 
                // hide video controller
                // var vids = $("video"); 
                // $.each(vids, function(){
                //        this.controls = false; 
                // }); 
                //Loop though all Video tags and set Controls as false

                $("video").click(function() {
                  //console.log(this); 
                  if (this.paused) {
                    this.play();
                } else {
                    this.pause();
                }
            });

                // $( '.sb-icon-search' ).click(function() {
                //   // alert( "Handler for .click() called." );
                //     console.log('enter submit');
                // // $('#sb-search').addClass('sb-search-open');
                // // $('.sb-search-input').addClass('animated fadeInRightBig');
                // });

                $( ".sb-icon-search" ).toggle(function() {
                  // console.log('enter submit');
                  $('#sb-search').addClass('sb-search-open');
                  $('.sb-search-input').addClass('animated fadeInRightBig');
              }, function() {
                  $('#sb-search').removeClass('sb-search-open');
              });

                $('.sb-ani-item').addClass('animated bounceInLeft');
                $(function(){ // document ready
                   if ($('#accordion-menu').length) { // make sure "#sticky" element exists
                      var el = $('#accordion-menu');
                      var stickyTop = $('#accordion-menu').offset().top; // returns number
                      var stickyHeight = $('#accordion-menu').height();

                      $(window).scroll(function(){ // scroll event
                          var limit = $('#footer').offset().top - stickyHeight - 20;

                          var windowTop = $(window).scrollTop(); // returns number

                          if (stickyTop < windowTop){
                           el.css({ position: 'fixed', top: 10 });
                       }
                       else {
                           el.css('position','static');
                       }

                       if (limit < windowTop) {
                          var diff = limit - windowTop;
                          el.css({top: diff});
                      }
                  });
                  }
              });

                // $(function() {

                //     var $sidebar   = $("#accordion-menu"), 
                //         $window    = $(window),
                //         offset     = $sidebar.offset(),
                //         sidebarHeight = $('#accordion-menu').height(),
                //         topPadding = 15;

                //     $window.scroll(function() {
                //         var limit = $('#footer').offset().top + sidebarHeight - 20;
                //         var footerTop = $('#footer').offset().top;
                //         var windowTop = $(window).scrollTop(); 

                //         // console.log('footerTop ='+footerTop);
                //         console.log('limit ='+limit);
                //         console.log('offset.top ='+ offset.top);
                //         console.log('$window.scrollTop() ='+ $window.scrollTop());


                //         if ($window.scrollTop() > offset.top) {
                //             $sidebar.stop().animate({
                //                 marginTop: $window.scrollTop() - offset.top + topPadding
                //             });
                //         } else {
                //             $sidebar.stop().animate({
                //                 marginTop: 0
                //             });
                //         }
                //     });
                // });

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },
        'market_area': {
            init: function() {
                //market_area对应 market-area页
                $( ".market-detail" ).hide();

                $('.nanchang').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/nanchang.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.ningbo').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/ningbo.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.wenzhou').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/wenzhou.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.hangzhou').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/hangzhou.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.jiangshu').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/jiangshu.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.ganzhou').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/ganzhou.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.zhangshu').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/zhangshu.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.hubei').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/hubei.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.liaoning').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/liaoning.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.heilongjiang').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/heilongjiang.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.hunan').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/hunan.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.beijing').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/beijing.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.xinjiang').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/xinjiang.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.sichuan').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/sichuan.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.guangdong').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/guangdong.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.fujian').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/fujian.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.neimeng').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/neimeng.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.jilin').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/jilin.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.anhui').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/anhui.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.henan').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/henan.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.hebei').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/hebei.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.shandong').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/shandong.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.shanxi').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/shanxi.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.chongqing').click(function() {
                    $('#area-content').load( "/wp-content/uploads/area/chongqing.html",function() {
                        var height = $('.market-inner').height();
                        $('.market-detail').height(height+20);
                    });
                    $('.market-detail').removeClass('animated flipOutX');
                    $('.market-detail').show();
                    $('.market-detail').addClass('animated flipInX');
                });

                $('.close-modal').click(function() {
                    $('.market-detail').addClass('animated flipOutX');
                });

                $('[data-toggle="tooltip"]').tooltip();
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page
                $("#banner-slider").slick({
                    autoplay: true,
                    dots: false,
                    prevArrow: '<button class="custom-prev"><i class="fa fa-lg fa-chevron-left" aria-hidden="true"></i></button>',
                    nextArrow: '<button class="custom-next"><i class="fa fa-lg fa-chevron-right" aria-hidden="true"></i></button>',
                    fade: true,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });

                $(".pic-news").slick({
                    dots: true,
                    dotsClass: 'slick-discs',
                    arrows: false,
                    fade: true,
                    cssEase: 'linear',
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1
                });

                // $('#txt1').addClass('animated flipInX');

                // $('.close-modal').click(function() {
                //     $('#notice_inner').toggle("slide");
                // });
                //wow init
                // new WOW().init();
            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                //For Firefox we have to handle it in JavaScript 
                // hide video controller
                var vids = $("video"); 
                $.each(vids, function(){
                 this.controls = false; 
             }); 
                // JavaScript to be fired on the about us page
            }
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
